import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { queryBuilder } from '@metromarkets/sdk';
import { Observable } from 'rxjs';
import { API_SEARCH_ATTRBIUTE_ROUTE_V3 } from '~app/modules/catalog/constants';
import { Attribute } from '~app/modules/filters/models';
import { RegionSelectorService } from '~shared/modules/region-selector/services';

@Injectable({
  providedIn: 'root',
})
export class BrandsService {
  constructor(private http: HttpClient, private regionSelectorService: RegionSelectorService) {}

  getBrandsByCategorySlug(categorySlug: string): Observable<Attribute[]> {
    let params = { 'attribute[code]': 'brand', 'filter[categories]': [categorySlug] };

    const userRegion = this.regionSelectorService.getUserRegion();
    if (userRegion) {
      params = { ...params, ...{ region: userRegion } };
    }

    const httpParams: HttpParams = queryBuilder.toParams(params) as HttpParams;

    return this.http.get<Attribute[]>(API_SEARCH_ATTRBIUTE_ROUTE_V3(), { params: httpParams });
  }
}
